const classname = (cssClass: string, condition: boolean, prefix = ' ') => (condition ? prefix + cssClass : '');

export default classname;
